/* import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import reportDownloadService from 'src/services/reportDownload.service';
import { hasPermission } from 'src/components/Permissions/hasPermission';


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import dayjs, { Dayjs } from 'dayjs';

import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { get } from 'src/services/httpClient.service';
import { authenticationService } from 'src/services/authentication.service';

const APIURL = process.env.REACT_APP_BASE_API_URL;

interface OTAHistoryItem {
  id: number;
  apkFileName: string;
  createdDate: string;
  apkFileUrl: string;
  description?: string;
}

const OtaLogReport = () => {
  const { vendorId } =
    authenticationService.getVendorFranchiseIds();

  const [rows, setRows] = useState<OTAHistoryItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState<Dayjs | null>(null);
  const [downloading, setDownloading] = useState({
  pdf: false,
  excel: false
  });

  const handleDownload = async (format: 'pdf' | 'excel') => {
  setDownloading((prev) => ({
    ...prev,
    [format]: true
  }));

  try {
    const fileName = `OTAHistory_${dayjs().format(
      'YYYYMMDD_HHmmss'
    )}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;

    const success = await reportDownloadService.downloadReport(
      {
        title: 'OTA History Report',
        columns,
        rows: filteredRows,
        month: dayjs().month() + 1,
        year: dayjs().year(),
        fileName,

        excelHeaders: [
          'APK Name',
          'Description',
          'Created Date'
        ],

        excelRowMapper: (row: any) => [
          row.apkFileName || '',
          row.description || '',
          row.createdDate
            ? new Date(row.createdDate).toLocaleString()
            : ''
        ]
      },
      format
    );

    if (!success) {
      alert(`Failed to generate ${format.toUpperCase()}`);
    }
  } catch (error) {
    console.error(error);
    alert(`Failed to generate ${format.toUpperCase()}`);
  } finally {
    setDownloading((prev) => ({
      ...prev,
      [format]: false
    }));
  }
};

  const fetchOTAHistory = async () => {
    try {
      setLoading(true);

      const response = await get(
        `${APIURL}/api/ota/vendor/${vendorId}/getOTAHistoryList`
      );

      const data = (response?.data || []).map(
        (item: OTAHistoryItem, index: number) => ({
          id: item.id || index + 1,
          apkFileName: item.apkFileName,
          description: item.description || '',
          createdDate: item.createdDate,
          apkFileUrl: item.apkFileUrl
        })
      );

      setRows(data);
    } catch (error) {
      console.error('Failed to fetch OTA history', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOTAHistory();
  }, []);

  

  const filteredRows = rows.filter((row) => {
    const searchMatch =
      row.apkFileName
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      row.description
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase());

    const dateMatch = filterDate
      ? dayjs(row.createdDate).format('DD/MM/YYYY') ===
        filterDate.format('DD/MM/YYYY')
      : true;

    return searchMatch && dateMatch;
  });

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 250
    },
    {
      field: 'apkFileName',
      headerName: 'APK Name',
      flex: 1,
      minWidth: 250
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
      minWidth: 350
    },
    {
      field: 'createdDate',
      headerName: 'Created Date',
      flex: 1,
      minWidth: 250,
      valueGetter: (params) =>
        params.row.createdDate
          ? new Date(params.row.createdDate).toLocaleString()
          : ''
    }
  ];

  return (
    <>
      <Helmet>
        <title>OTA History</title>
      </Helmet>

      

      <PageTitleWrapper>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }}
  >
    <PageTitle
      heading="OTA History"
      subHeading="View OTA APK upload history"
      handleClick={undefined}
    />

    {hasPermission(['OWNER']) && (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={() => handleDownload('excel')}
          disabled={downloading.excel}
        >
          {downloading.excel
            ? 'Generating...'
            : 'Excel'}
        </Button>

        <Button
          variant="outlined"
          startIcon={<PictureAsPdfIcon />}
          onClick={() => handleDownload('pdf')}
          disabled={downloading.pdf}
        >
          {downloading.pdf
            ? 'Generating...'
            : 'PDF'}
        </Button>
      </Box>
    )}
  </Box>
</PageTitleWrapper>

      <Box sx={{ px: 2, mb: 3 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            <TextField
              label="Search APK"
              size="small"
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
              sx={{ width: 300 }}
            />

            <DatePicker
              label="Created Date"
              value={filterDate}
              onChange={(value) =>
                setFilterDate(value)
              }
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: 250 }
                }
              }}
            />

            <Button
              variant="outlined"
              onClick={() => {
                setSearchTerm('');
                setFilterDate(null);
              }}
            >
              Clear Filters
            </Button>
          </Box>
        </LocalizationProvider>
      </Box>

      <Box
        sx={{
          width: '100%',
          px: 2
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          loading={loading}
          autoHeight={false}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50, 100]}
          disableSelectionOnClick
          sx={{
            height: '75vh',
            border: 2,
            borderColor: 'rgb(43 44 45)',

            '& .MuiDataGrid-columnHeaders': {
              minHeight: '60px !important',
              maxHeight: '60px !important',
              fontSize: '16px',
              fontWeight: 700
            },

            '& .MuiDataGrid-row': {
              minHeight: '60px !important'
            },

            '& .MuiDataGrid-cell': {
              fontSize: '15px',
              display: 'flex',
              alignItems: 'center'
            }
          }}
        />
      </Box>
    </>
  );
};

export default OtaLogReport;

 */

import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  CircularProgress,
  Chip,
  Button,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import dayjs from "dayjs";
import axios from "axios";
import { get } from 'src/services/httpClient.service';
import { authenticationService } from "src/services";
const API_URL = process.env.REACT_APP_BASE_API_URL;
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";


interface OtaLog {
  id: string;
  vendorId: string;
  userId: number;
  customerId: string | null;
  versionName: string;
  versionCode: string;
  otaUpdatedDate: string;
  createdDate: string;
  deviceInfo: string;
  ipAddress: string;
  userAgent: string;
  status: string;
}

const OtaUpdateLogs = () => {
  const [rows, setRows] = useState<OtaLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const [filterDate, setFilterDate] = useState<Dayjs | null>(null);

  const fetchLogs = async () => {
    try {
      setLoading(true);

      const response = await get(
        `${API_URL}/api/ota/vendor/${vendorId}/getOtaUpdateLogs`
      );

      setRows(response?.data || []);
    } catch (error) {
      console.error(error);
      alert("Failed to fetch OTA Logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const filteredRows = useMemo(() => {
  return rows.filter((row) => {
    const searchMatch =
      !search ||
      Object.values(row).some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );

    const dateMatch = filterDate
      ? dayjs(row.createdDate).format("DD/MM/YYYY") ===
        filterDate.format("DD/MM/YYYY")
      : true;

    return searchMatch && dateMatch;
  });
}, [rows, search, filterDate]);

  const columns: GridColDef[] = [
    {
      field: "userId",
      headerName: "User ID",
      width: 110,
    },
    {
      field: "customerId",
      headerName: "Customer ID",
      width: 150,
      renderCell: (params) => params.value || "-",
    },
    {
      field: "deviceInfo",
      headerName: "Device ID",
      width: 220,
    },
    {
      field: "versionName",
      headerName: "Version",
      width: 120,
    },
    {
      field: "versionCode",
      headerName: "Version Code",
      width: 140,
    },
    {
      field: "otaUpdatedDate",
      headerName: "OTA Updated",
      width: 190,
      renderCell: (params) =>
        params.value
          ? dayjs(params.value).format("DD-MM-YYYY HH:mm:ss")
          : "-",
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 190,
      renderCell: (params) =>
        params.value
          ? dayjs(params.value).format("DD-MM-YYYY HH:mm:ss")
          : "-",
    }
    
  ];

  

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        m: 2,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
      >
        OTA Update Logs
      </Typography>

     <LocalizationProvider dateAdapter={AdapterDayjs}>
  <Box
    sx={{
      display: "flex",
      gap: 2,
      mb: 2,
      alignItems: "center",
      flexWrap: "wrap",
    }}
  >
    <TextField
      label="Search"
      size="small"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      sx={{ width: 300 }}
    />

    <DatePicker
      label="Created Date"
      value={filterDate}
      onChange={(newValue) => setFilterDate(newValue)}
      format="DD/MM/YYYY"
      slotProps={{
        textField: {
          size: "small",
          sx: { width: 220 },
        },
      }}
    />

    <Button
      variant="outlined"
      onClick={() => {
        setSearch("");
        setFilterDate(null);
      }}
    >
      Clear
    </Button>
  </Box>
</LocalizationProvider>

      <Box
        sx={{
          height: 400,
          width: "100%",
        }}
      >
        <DataGrid
  rows={filteredRows}
  columns={columns}
  getRowId={(row) => row.id}
  loading={loading}
  pageSize={10}
  rowsPerPageOptions={[10, 20, 50, 100]}
  disableSelectionOnClick
  components={{
    Toolbar: GridToolbar,
    LoadingOverlay: CircularProgress,
  }}
/>
      </Box>
    </Paper>
  );
};

export default OtaUpdateLogs;